import React from 'react';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { RetiradorForm } from './RetiradorForm';
import type { RetiradorData, RetiradorErrors } from '../../types';

interface RetirarCopiasStep2SingleProps {
  cantidadCopias: number;
  fechaRetiro: string;
  onFechaChange: (fecha: string) => void;
  retirador: RetiradorData;
  onRetiradorChange: (retirador: RetiradorData) => void;
  errors?: RetiradorErrors;
  disabled?: boolean;
}

export const RetirarCopiasStep2Single: React.FC<RetirarCopiasStep2SingleProps> = ({
  cantidadCopias,
  fechaRetiro,
  onFechaChange,
  retirador,
  onRetiradorChange,
  errors = {},
  disabled = false,
}) => {
  return (
    <div className="space-y-6 min-w-0 overflow-hidden">
      {/* Info de copias */}
      <div className="rounded-lg bg-blue-50 border border-blue-200 p-4">
        <p className="text-sm text-blue-900">
          Se retirarán <span className="font-semibold">{cantidadCopias}</span> {cantidadCopias === 1 ? 'copia' : 'copias'}
        </p>
      </div>

      {/* Fecha de retiro */}
      <div className="space-y-2">
        <Label htmlFor="fecha-retiro">
          Fecha de Retiro
          <span className="text-red-500 ml-1">*</span>
        </Label>
        <Input
          id="fecha-retiro"
          type="date"
          value={fechaRetiro}
          onChange={(e) => onFechaChange(e.target.value)}
          max={new Date().toISOString().split('T')[0]}
          disabled={disabled}
        />
      </div>

      {/* Formulario del retirador */}
      <RetiradorForm
        retirador={retirador}
        onChange={onRetiradorChange}
        errors={errors}
        maxCopias={cantidadCopias}
        disabled={disabled}
      />
    </div>
  );
};
